import { Avatar } from '@/components/avatar';
import { BORDER_WIDTH, SnakeBorderView } from '@/components/snake-border-view';
import { createStyles } from '@/contexts/theme-context';
import {
  OrderSourceIcon,
  type Props as OrderSourceIconProps,
  SOURCE_ICON_SIZE,
} from '@/components/order-source-icon';
import { View } from 'react-native';
import type { OrderInboundAssignedEmployee } from './types';

interface Props extends OrderSourceIconProps {
  assignedEmployee?: OrderInboundAssignedEmployee;
  isProcessing?: boolean;
}

export const OrderInboundsListItemSourceIcon = ({
  assignedEmployee,
  isProcessing,
  ...rest
}: Props) => {
  const [styles] = useStyles();

  return (
    <View style={styles.container}>
      {isProcessing ? (
        <SnakeBorderView
          baseStyle={[styles.leftIconBorderRadius]}
          innerStyle={[styles.leftIconBorderRadius, styles.leftIconBorder]}
        >
          <OrderSourceIcon {...rest} />
        </SnakeBorderView>
      ) : (
        <View style={styles.inactiveBorder}>
          <OrderSourceIcon {...rest} />
        </View>
      )}

      {assignedEmployee ? (
        <Avatar
          containerStyle={[
            isProcessing
              ? styles.avatarContainerIsProcessing
              : styles.avatarContainer,
          ]}
          name={assignedEmployee.name}
          size="xsmall"
          uuid={assignedEmployee.uuid}
        />
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  avatarContainer: {
    position: 'absolute',
    right: -2,
    top: 26,
  },
  avatarContainerIsProcessing: {
    position: 'absolute',
    right: 0,
    top: 28,
  },
  container: {
    position: 'relative',
  },
  inactiveBorder: {
    borderColor: theme.colors.transparent,
    borderRadius: SOURCE_ICON_SIZE,
    borderWidth: BORDER_WIDTH,
  },
  leftIconBorder: {
    backgroundColor: theme.colors.transparent,
  },
  leftIconBorderRadius: {
    borderRadius: SOURCE_ICON_SIZE,
  },
}));
